module.exports = __webpack_public_path__ + "assets/explore-5a9954edfed5a2312b87c82946a4bfdb.svg";